module.exports = __webpack_public_path__ + "static/media/SectionCut.248be063.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd503/SectionCut.png
// module id = 177
// module chunks = 0